import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Badge from '@mui/material/Badge';
import { useEffect, useState } from 'react';
import { postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import PaymentContent from './PaymentContent';

interface TabPanelProps {
  children?: React.ReactNode;
  dir?: string;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

const a11yProps = (index: number) => {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
};

const badgeStyle = {
  '&.MuiBadge-root .MuiBadge-badge': {
    color: 'primary.light',
    bgcolor: '#FC6E51',
    right: '-10px',
  },
};

const PaymentList = () => {
  const [payments, setPayments] = useState<any>([]);
  const [unPayments, setUnPayments] = useState<any>([]);
  // const [pagination, setPagination] = useState<PaginationType>();
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const getPayments = async (page: number) => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      postAPI(`/patient/search?token=${token}`, {
        page: page,
        pagesize: 10,
      })
        .then((res: any) => {
          if (res.code === 200 && res.data) {
            setPayments(res.data.payments);
            setUnPayments(res.data.unpayments);
            // setPagination(res.data.pagination);
          }
        })
        .finally(() => {});
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  useEffect(() => {
    getPayments(1);
    // eslint-disable-next-line
  }, []);

  // const handlePageChange = (eventL: any, value: number) => {
  //   getPayments(value);
  // };

  return (
    <Stack width={'100%'}>
      <Tabs
        value={value}
        onChange={handleChange}
        variant='fullWidth'
        aria-label='full width tabs'
        sx={{
          bgcolor: 'primary.light',
          '&.MuiTabs-root .MuiTabs-indicator': {
            bgcolor: '#FC6E51',
            top: 0,
          },
          '& .MuiButtonBase-root.MuiTab-root': {
            color: '#A3AED0',
            fontSize: '14px',
            fontWeight: 700,
          },
          '& .MuiButtonBase-root.MuiTab-root.Mui-selected': {
            color: '#FC6E51',
          },
        }}
      >
        <Tab
          label={
            <Badge badgeContent={payments.length} sx={badgeStyle}>
              未収金
            </Badge>
          }
          {...a11yProps(0)}
        />
        <Tab
          label={
            <Badge badgeContent={unPayments.length} sx={badgeStyle}>
              未納金
            </Badge>
          }
          {...a11yProps(1)}
        />
      </Tabs>
      <TabPanel value={value} index={0}>
        <PaymentContent data={payments} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <PaymentContent data={unPayments} />
      </TabPanel>

      {/* {data.length > 0 && pagination && (
        <Box display={'flex'} justifyContent={'right'} mt={'10px'}>
          <Typography
            component='label'
            sx={{
              color: '#AAB2BD',
              fontWeight: '400',
              fontSize: '10px',
              lineHeight: '12px',
            }}
          >
            {getDetailPagin(pagination)}
          </Typography>
        </Box>
      )}
      {data.length > 0 && pagination && pagination.page && (
        <Pagin handlePageChange={handlePageChange} pagination={pagination} />
      )} */}
    </Stack>
  );
};

export default PaymentList;
